var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-icon',{staticClass:"animate-spin filter grayscale",class:[`w-${_vm.size} h-${_vm.size}`],attrs:{"name":"logo-wheat-only","alt":"Loading"}})
}
var staticRenderFns = []

export { render, staticRenderFns }